import React from "react";

const Dropdown = ({ options, value, onChange, placeholder }) => (
  <select
    onChange={(e) => onChange(e.target.value)}
    value={value}
    style={{
      width: "100%",
      padding: "12px",
      fontSize: "16px",
      borderRadius: "5px",
      border: "1px solid #ddd",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    }}
  >
    <option value="">{placeholder}</option>
    {options.map((option, index) => (
      <option key={index} value={option}>
        {option}
      </option>
    ))}
  </select>
);

export default Dropdown;